
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^webpack_container_remote_(chat|explore|itineraries|landing)_Module$/.test(chunkId);
},
rootOutputDir: "",

    };
}
